import React from 'react';
import { Pressable } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// "Settings" text button for the Screen header; opens the PlanogramDetail
// filter dialog (pass the same toggle as PlanogramDetail's toggleSettingsDialog).
const PlanogramSettingsButton = ({ onPress, accessibilityLabel = 'List settings' }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<Pressable
			onPress={onPress}
			accessibilityRole="button"
			accessibilityLabel={accessibilityLabel}
			style={({ pressed }) => [styles.button, pressed && styles.pressed]}
		>
			<Text style={styles.label}>Settings</Text>
		</Pressable>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	button: {
		minHeight: 44,
		paddingHorizontal: space.sm,
		justifyContent: 'center',
	},
	label: {
		...type.rowTitle,
		color: colors.accent,
	},
	pressed: {
		opacity: 0.7,
	},
});

export default PlanogramSettingsButton;
